<template>
  <div>
    <nav class="navbar fixed-top" id="nav">
      <div class="container" >
        <div class="home" @click="goToHomePage()">
          <img src="../assets/images/brand-icon.png" class="d-inline" alt="" width="40px">
          <h3 class="text-logo d-inline" style="margin:5px;">MarketPlace</h3>
        </div>
        
        <span class="initialize" v-if="user"  id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div class="box-image-profile">
            <img :src="`https://images.horganice.in.th/users/thumbnails/${user.id}.jpg`" v-if="!isNoImage" @error="errorImage()" alt="" >
            <img src="../assets/images/default-user-image.png" v-if="isNoImage">
          </div>
          {{ user.get('userProfile').get('firstName') }} 
          <span class="fa fa-caret-down"></span>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" @click="logout()">ออกจากระบบ</a>
          </div>
        </span>
        
        
        <span class="initialize" v-else>
          <a :href="`${$webAppUrl}/login?redirect=marketplace`" @click="trackMixpanel('click-login')" class="initialize-menu" target="_blank"><span class="fas fa-user-circle" style="font-size:23px; position:relative; top: 2px;"></span>  เข้าสู่ระบบ</a> | <a :href="`${$webAppUrl}/pre-signup?utm_source=marketplace`" @click="trackMixpanel('click-register')" target="_blank" class="initialize-menu">สมัครสมาชิก</a>
        </span>

      </div>
    </nav>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      isNoImage: false
    }
  },
  computed:{
    ...mapState([
      'apartment',
      'carts',
      'user'
    ]),
  },
  methods:{
    goToHomePage(){
      $("#main-cid-detail").removeClass("modal-open");
      $("#modal-purchase").addClass("modal-purchase-hide");
      if(this.carts && this.carts.length > 0){
        $("#cart-bar").removeClass("hide-cart");
        $("#cart-bar").addClass("show-cart");
      }
      this.$router.push({ name: 'home'})
    },
    async logout(){

      // ------------------------mixpanel---------------------------
      if(this.user) this.$mixpanel.track(`click-logout`, {id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName')})
      else this.$mixpanel.track(`click-logout`)
      // -----------------------------------------------------------

      await this.Parse.User.logOut();
      location.replace("/")
    },
    trackMixpanel(trackName){
      // ------------------------mixpanel---------------------------
      this.$mixpanel.track(trackName)
      // -----------------------------------------------------------
    },
    errorImage(){
      this.isNoImage = true
    }
  }
}
</script>
<style scoped>
a{
  color: white;
}
.navbar{
  background-color: #e9773b;
  z-index: 18;
  height: 53px;
}
.container{
  position: relative;
  max-width: 1300px;
}
.home{
  cursor: pointer;
  position: relative;
}
.text-logo{
  font-size: 25px;
  font-weight: bold;
  color: white;
  position: relative;
  top: 4px;
}
.box-image-profile{
  display: inline;
  
}
.box-image-profile img{
  width: 30px;
  border-radius: 50%;
}
.initialize{
  color: white;
  cursor: pointer;
}
.initialize-menu:hover{
  color: rgb(235, 235, 235);
  text-decoration: none;
}
.dropdown-menu{
  right: 0;
  left: auto;
  border: 1px solid rgba(148, 148, 148, 0.5);
  cursor: pointer;
  color: rgb(80, 80, 80);
}
.dropdown-item:active{
  background: rgb(200, 200, 200);
}
@media only screen and (max-width: 768px) {
  .text-logo{
    display: none !important;
  }
}
</style>